module.exports = __webpack_public_path__ + "static/rectangle-491b619d1ad331479b22fd8a629d40db.svg";